var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-container",
    {
      attrs: {
        fluid: ""
      }
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Select Your App ")]),
          _c(
            "gg-card-text",
            {
              staticClass: "overflow-visible"
            },
            [
              _c(
                "v-item-group",
                {
                  attrs: {
                    "active-class": "primary"
                  },
                  model: {
                    value: _vm.selection,
                    callback: function callback($$v) {
                      _vm.selection = $$v
                    },
                    expression: "selection"
                  }
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "my-3"
                    },
                    _vm._l(_vm.items, function(item) {
                      return _c(
                        "v-col",
                        {
                          key: item.key,
                          attrs: {
                            cols: "12",
                            md: "4"
                          }
                        },
                        [
                          _c("v-item", {
                            attrs: {
                              value: item
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function fn(_ref) {
                                    var active = _ref.active,
                                      toggle = _ref.toggle
                                    return [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass:
                                            "app-card d-flex align-center relative overflow-visible",
                                          attrs: {
                                            height: "248"
                                          },
                                          on: {
                                            click: toggle
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    item.key === "extendify",
                                                  expression:
                                                    "item.key === 'extendify'"
                                                }
                                              ],
                                              staticClass: "most-popular"
                                            },
                                            [_vm._v("Recommended")]
                                          ),
                                          _c(
                                            "v-card-text",
                                            {
                                              staticClass:
                                                "d-flex flex-col items-center full-height justify-space-between py-4",
                                              style: _vm.cardActiveStyle(active)
                                            },
                                            [
                                              _c("v-img", {
                                                staticClass: "ma-auto",
                                                attrs: {
                                                  src: _vm.wizardIcon(item),
                                                  "max-height": "60",
                                                  contain: ""
                                                }
                                              }),
                                              _c("h3", [
                                                _vm._v(
                                                  " " + _vm._s(item.name) + " "
                                                )
                                              ]),
                                              _c(
                                                "h5",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !!item.subtitle,
                                                      expression:
                                                        "!!item.subtitle"
                                                    }
                                                  ]
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.subtitle) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "text-center"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.description) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "gg-btn",
                                                {
                                                  attrs: {
                                                    tile: "",
                                                    color: active
                                                      ? "white"
                                                      : "primary",
                                                    outlined: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        active
                                                          ? "Selected"
                                                          : "Select"
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }